function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/contextplugin
 */
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * The base class for {@link module:core/context~Context} plugin classes.
 *
 * A context plugin can either be initialized for an {@link module:core/editor/editor~Editor editor} or for
 * a {@link module:core/context~Context context}. In other words, it can either
 * work within one editor instance or with one or more editor instances that use a single context.
 * It is the context plugin's role to implement handling for both modes.
 *
 * There are a few rules for interaction between the editor plugins and context plugins:
 *
 * * A context plugin can require another context plugin.
 * * An {@link module:core/plugin~Plugin editor plugin} can require a context plugin.
 * * A context plugin MUST NOT require an {@link module:core/plugin~Plugin editor plugin}.
 *
 * @implements module:core/plugin~PluginInterface
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var ContextPlugin =
/*#__PURE__*/
function () {
  /**
   * Creates a new plugin instance.
   *
   * @param {module:core/context~Context|module:core/editor/editor~Editor} context
   */
  function ContextPlugin(context) {
    _classCallCheck(this, ContextPlugin);

    /**
     * The context instance.
     *
     * @readonly
     * @type {module:core/context~Context|module:core/editor/editor~Editor}
     */
    this.context = context;
  }
  /**
   * @inheritDoc
   */


  _createClass(ContextPlugin, [{
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "isContextPlugin",
    get: function get() {
      return true;
    }
  }]);

  return ContextPlugin;
}();

export { ContextPlugin as default };
mix(ContextPlugin, ObservableMixin);